import TextCollapse from './TextCollapse.view';

export default TextCollapse;
